<template>
    <cod-dialog
        class="select-order-item-comments"
        :show.sync="showDialog"
        max-width="750px"
    >
        <!-- Header -->
        <template slot="header">
            <v-toolbar-title>
                {{ $t('order.exempt_from_tax') }}
            </v-toolbar-title>
        </template>

        <div slot="content">
            <div class="select-order-item-comments-content">
                <v-text-field
                    v-model="filter"
                    class="mb-8"
                    :label="$t('general.search')"
                    append-icon="far fa-search"
                    clearable
                    clear-icon="fal fa-times"
                    single-line
                    hide-details
                />

                <v-item-group
                    v-model="selectedIndex"
                    single
                >
                    <v-item
                        v-for="(reason, index) in exemptFromTaxReasonsFiltered"
                        :key="index"
                        v-slot="{ active, toggle }"
                    >
                        <v-checkbox
                            class="my-0"
                            :label="reason.label"
                            :value="active"
                            @change="toggle"
                        />
                    </v-item>
                </v-item-group>
            </div>
        </div>

        <template slot="footer">
            <v-btn
                class="flex-1 mr-1"
                color="primary"
                outlined
                @click="showDialog = false"
            >
                {{ $t('general.close') }}
            </v-btn>

            <v-btn
                class="flex-1 ml-1"
                color="primary"
                depressed
                @click="save"
            >
                {{ $t('general.confirm') }}
            </v-btn>
        </template>
    </cod-dialog>
</template>

<script>
import CodDialog from '@/components/CodDialog';

export default {
    name: 'SelectExemptFromTax',

    components: {
        CodDialog,
    },

    props: {
        show: {
            type: Boolean,
            default: false
        },
        order: {
            type: Object,
            default: () => null
        },
        orderItem: {
            type: Object,
            default: () => null
        }
    },

    created() {
    },

    data: () => ({
        showDialog: false,
        selectedIndex: null,
        filter: null
    }),

    watch: {
        show(val) {
            this.showDialog = val;

            if(val) {
                this.filter = null;

                this.$nextTick(() => {
                    this.selectedIndex = this.exemptFromTaxReasonsFiltered.findIndex(reason => {
                        return reason.code === this.orderItem.exempt_from_tax;
                    })
                })
            } else {
                this.selectedIndex = null;
                this.filter = null;
            }
        },

        showDialog(val) {
            this.$emit('update:show', val);
        },
    },

    computed: {
        exemptFromTaxReasonsFiltered() {
            if(!this.order || !this.orderItem) return [];

            let reasons = OrderItem.exemptFromTaxReasons;

            if(locale === 'sr') {
                const otherItemsWithExemptFromTax = this.order.items.filter(item => {
                    return !!item.exempt_from_tax && item.hash !== this.orderItem.hash;
                });

                if(otherItemsWithExemptFromTax.length) {
                    const previouslySelectedReasons = otherItemsWithExemptFromTax.map(orderItem => {
                        return reasons.find(reason => reason.code === orderItem.exempt_from_tax.split('|')[0]);
                    })

                    reasons = reasons.filter(reason => {
                        const categoryWasPreviouslySelected = previouslySelectedReasons.some(r => r.category === reason.category);
                        if(!categoryWasPreviouslySelected) return true;

                        return previouslySelectedReasons.some(r => r.code === reason.code);
                    });
                }
            }

            if(!this.filter) return reasons;

            const filter = this.filter.toLowerCase();
            return reasons.filter(reason => reason.label.toLowerCase().includes(filter));
        }
    },

    methods: {
        save() {
            this.showDialog = false

            const reason = !isNaN(this.selectedIndex) ? this.exemptFromTaxReasonsFiltered[this.selectedIndex] : null

            this.$emit('save', {
                item: this.orderItem,
                exemptFromTaxReason: reason ? (reason.code + (reason.category ? '|' + reason.category : '')) : null
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.select-order-item-comments-content {
    padding: 20px;
    height: 500px;
}
</style>
